import { Controller, Control, FieldErrors } from 'react-hook-form';
import { MenuItem, TextField, TextFieldProps } from '@mui/material';

type ControlledTextFieldProps = {
    name: string;
    control: Control<any>;
    label: string;
    errors: FieldErrors;
    options: { value: string; label: string }[];
    defaultValue?: string;
    type?: string;
} & TextFieldProps;

export default function SingleSelect({
    name,
    control,
    errors,
    defaultValue = '',
    type = 'text',
    options,
    ...rest
}: ControlledTextFieldProps) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field }) => (
                <TextField
                    {...field}
                    {...rest}
                    select
                    type={type}
                    error={!!errors[name]}
                    helperText={(errors[name]?.message as string) || ''}
                >
                    {options.map((option) => {
                        return <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>;
                    })}
                </TextField>
            )}
        />
    );
}
